// Function to register the service worker
const swDev = () => {
  // Check if service workers are supported
  if ("serviceWorker" in navigator) {
    console.log("Service Worker supported!");
    
    // Wait for the page to fully load
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/sw.js`;
      
      // First, unregister any existing service workers to ensure clean installation
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (let registration of registrations) {
          // Only log in development
          if (process.env.NODE_ENV === 'development') {
            console.log("Unregistering previous service worker");
          }
          registration.unregister();
        }
        
        // Now register the new service worker
        navigator.serviceWorker
          .register(swUrl)
          .then((registration) => {
            console.log("Service Worker Registered with scope:", registration.scope);
            
            // Check for updates
            registration.onupdatefound = () => {
              const installingWorker = registration.installing;
              if (installingWorker == null) {
                return;
              }
              
              installingWorker.onstatechange = () => {
                if (installingWorker.state === "installed") {
                  if (navigator.serviceWorker.controller) {
                    // At this point, the updated precached content has been fetched,
                    // but the previous service worker will still serve the older
                    // content until all client tabs are closed.
                    console.log(
                      "New content is available and will be used when all tabs for this page are closed."
                    );
                  } else {
                    // At this point, everything has been precached.
                    console.log("Content is cached for offline use.");
                  }
                }
              };
            };
          })
          .catch((error) => {
            console.error("Error registering service worker:", error);
          });
      });
      
      // Add debug features for development mode
      if (process.env.NODE_ENV === 'development') {
        // Expose a function to check service worker status
        window.checkServiceWorker = () => {
          if (navigator.serviceWorker.controller) {
            console.log("Service worker is active and controlling the page");
            return true;
          } else {
            console.log("Service worker is not controlling the page yet");
            return false;
          }
        };
        
        // Expose a function to debug cache
        window.debugCache = () => {
          if (!navigator.serviceWorker.controller) {
            console.log("No service worker controlling the page");
            return;
          }
          
          const msgChannel = new MessageChannel();
          msgChannel.port1.onmessage = (event) => {
            console.log("Cache status:", event.data.debug);
          };
          
          navigator.serviceWorker.controller.postMessage({
            action: 'debug'
          }, [msgChannel.port2]);
        };
      }
    });
    
    // Add service worker update handling - refresh page on update
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true;
        console.log("New service worker activated, reloading for fresh content...");
        window.location.reload();
      }
    });
  } else {
    console.log("Service Workers are not supported in this browser");
  }
};

export default swDev;